import { render, staticRenderFns } from "./LlScrollableBlockContent.vue?vue&type=template&id=59e60c8d"
import script from "./LlScrollableBlockContent.vue?vue&type=script&lang=js"
export * from "./LlScrollableBlockContent.vue?vue&type=script&lang=js"
import style0 from "./LlScrollableBlockContent.vue?vue&type=style&index=0&id=59e60c8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports